
 document.addEventListener("DOMContentLoaded", (event) => {
  // Play video event handler
  $(document).on('click', '.playButton233', function(e) {
    e.stopPropagation();
    var $videoContainer = $(this).closest('.mwm_list_video');
    var $playButton = $(this);
    var $pauseIcon = $videoContainer.find('.pause_icon233');
    var $allVideos = $('.mutli_off175'); // Select all videos
    var $allPauseIcons = $('.pause_icon233'); // Select all pause icons

    // Pause all videos and hide pause icons except the current one
    $allVideos.each(function() {
      if (this !== $videoContainer.find('.mutli_off175')[0]) {
        $(this).trigger('pause');
      }
    });

    // Show play button for the previously playing video
    var $previouslyPlayingVideo = $('.mwm_list_video.playing');
    if ($previouslyPlayingVideo.length > 0) {
      $previouslyPlayingVideo.find('.playButton233').show();
      $previouslyPlayingVideo.find('.pause_icon233').hide();
      $previouslyPlayingVideo.removeClass('playing');
    }

    $allPauseIcons.hide(); // Hide all pause icons
    var videoID = "myVideo145" + $videoContainer.find('.playToggle221').attr('data-container');
    $videoContainer.find('.mutli_off175').trigger('play');
    $playButton.hide();
    $pauseIcon.show();
    $videoContainer.addClass('playing');
  });

  // Pause video event handler
  $(document).on('click', '.pause_icon233', function(e) {
    e.stopPropagation();
    var $videoContainer = $(this).closest('.mwm_list_video');
    var $pauseIcon = $(this);
    var $playButton = $videoContainer.find('.playButton233');
    $videoContainer.find('.mutli_off175').trigger('pause');
    $playButton.show();
    $pauseIcon.hide();
    $videoContainer.removeClass('playing');
  });

  // Hide the pause button initially
  $('.pause_icon233').hide();

  // Show the pause button on mouse enter if video is playing
  $(document).on('mouseenter', '.mwm_list_video', function() {
    var $videoContainer = $(this);
    if ($videoContainer.hasClass('playing')) {
      $videoContainer.find('.pause_icon233').show();
    }
  });

  // Hide the pause button on mouse leave
  $(document).on('mouseleave', '.mwm_list_video', function() {
    $(this).find('.pause_icon233').hide();
  });

  // Pause video when changing tabs
  $('.tab').on('click', function() {
    var $videoContainer = $('.mwm_list_video.playing');
    if ($videoContainer.length > 0) {
      $videoContainer.find('.mutli_off175').trigger('pause');
      $videoContainer.find('.playButton233').show();
      $videoContainer.find('.pause_icon233').hide();
      $videoContainer.removeClass('playing');
    }
  });

});
